export { default as ShieldExclamationIcon } from './ShieldExclamationIcon';
